const language = {
    'pt': 
        {
            add_new:            'Adicionar novo',
            birthday:         'Data de nascimento',
            cancel:             'Cancelar', back: 'Voltar',
            close:              'Fechar',
            config:             'Configuração',
            content:            'Conteúdo',
            content_edit:       'Editar conteúdo',
            content_new:        'Novo conteúdo',
            content_list:       'Lista de conteúdos',
            country:                'País',
            country_placeholder:    'Introduza o país',
            city:                   'Cidade',
            city_placeholder:       'Introduza a cidade',
            district:               'Distrito',
            district_placeholder:   'Introduza o distrito',
            local:                  'Localidade',
            local_placeholder:      'Introduza a localidade',
            morada:                 'Morada',
            morada_placeholder:     'Introduza a morada',
            postal_code:                'Código-postal',
            postal_code_placeholder:    'Introduza o código-postal',
            village:                'Freguesia',
            village_placeholder:    'Introduza a freguesia',
            dark_mode:          'Dark mode',
            dates:              'Datas',
            date_creation:      'Criação',
            date_publication:   'Publicação',
            date_last_update:   'Última actualização',
            delete:             'Eliminar',
            delete_title:       'Eliminar Registo',
            delete_text:        'Tem a certeza que pretende continuar?',
            delete_confirm:     'Sim',
            delete_cancel:      'Não',
            delete_error:       'Problema ao apagar registo!',
            delete_success:     'Registo apagado com sucesso!',
            description:        'Descrição',
            description_placeholder: 'Introduza uma descrição',
            edit:               'Editar',
            edit_title:         'Editar Registo',
            edit_text:          'Tem a certeza que pretende continuar?',
            edit_confirm:       'Sim',
            edit_cancel:        'Não',
            edit_error:         'Problema ao actualizar registo!',
            edit_success:       'Registo actualizado com sucesso!',
            email:              'E-mail da empresa', 
            email_placeholder:  'Introduza o e-mail', 
            entity:             'Empresa02',  
            entity_edit:        'Editar cliente',
            entity_new:         'Registo de uma nova empresa',
            entity_list:        'Lista de clientes', 
            filter_placeholder: 'Procurar',
            id:                 'ID',
            language:           'Lingua',
            login_data:         'Informação de caráter privado',
            name:               'Nome da empresa',
            name_placeholder:   'Introduza o nome',
            vat:                'NIF',
            vat_placeholder:    'Introduza o NIF',
            identification_number:              'Número de identificação',
            identification_number_placeholder:  'Introduza o número de identificação',
            identification_validation:          'Validade',
            image:              'Imagem',
            image_choose:       'Escolher imagem',
            insert_title:       'Novo Registo',
            insert_text:        'Tem a certeza que pretende continuar?',
            insert_confirm:     'Sim',
            insert_cancel:      'Não',
            insert_error:       'Problema ao inserir registo!',
            insert_success:     'Registo inserido com sucesso!',
            password:           'Password',
            password_confirmation:  'Confirmação da Password',
            password_placeholder:   'Introduza a password',
            password_title:     'Password!',
            password_text:      'As Passwords não correspondem.',
            password_confirm:   'Continue',
            password_cancel:    'No',
            password_error:     'Problem inserting element!',
            password_success:   'Successful inserted element!', 
            personal_data:      'Informação de caráter público',
            principal:          'Principal',
            profile:            'Perfil',
            remove:             'Remover',
            table_rows_per_page:'Registos por página:',
            table_separator:    'de',
            table_all:          'Todos',
            table_thumbnail:    'Thumbnail',
            table_title:        'Título',
            table_parent:       'Parent',
            table_date:         'Data',
            table_type:         'Tipo',
            table_count:        'Count',
            table_state:        'Estado',
            table_actions:      'Acções',
            table_empty:        'sem resultados',
            text:               'Texto',
            title:              'Título',
            title_placeholder:  'Introduza o título',
            tlf:                'Telefone', 
            tlf_placeholder:    'Introduza o número de telefone', 
            tlm:                'Telemóvel', 
            tlm_placeholder:    'Introduza o número de telemóvel', 
            type:               'Tipo de cliente',
            type_placeholder:   'Introduza o tipo de cliente',
            type_identification:                'Tipo de identificação',
            type_identification_placeholder:    'Introduza o tipo de identificação',
            save:               'Salvar', 
            username:           'Username', 
            username_placeholder: 'Introduza o username', 
            warning_title:      'Aviso!',
            warning_text:       'O username já existe no sistema.',
            warning_confirm:    'Continuar',
            warning_cancel:     'Não',
            warning_error:      'Problema ao inserir registo!',
            warning_success:    'Registo inserido com sucesso!',
            //ADD
            main_function: "Áreas de atuação da empresa",
            main_function_placeholder: "IT, Marketing, Administrativo... ",
            website: "Website",
            website_placeholder: "Insira o website",
            permissions_text: "Todas as permissões",
            departments: "Departamentos da empresa",
            department_placeholder: "Consultoria, ambiente...",
            employeer_name: "Nome do trabalhador",
            employeer_name_placeholder: "Introduza o nome",
            employeer_role: "Função na empresa",
            employeer_role_placeholder: "Programador, Ladrilheiro...",
            employeer_department: "Em qual departamento trabalha?",
            employeer_type: "Tipo de trabalhador",
            employeer_type_placeholder: "CEO, Manager, CFO, funcionário...",
            employeer_id: "Identificação do funcionário",
            employeer_id_placeholder: "Insira um número",
            employeer_insurance: "Número do seguro",
            employeer_insurance_placeholder: "Insira um número",
            employeer_email: "E-mail do funcionário",
            employeer_email_placeholder: "Introduza o e-mail",
            add_entity: 'Adicionar outros departamentos', //teste
            add_contact: "Número de telemóvel",
            add_resp_name: "Nome do responsável",
            add_depart_name: "Nome do departamento",
            entidades: "Entidades",
            dominios: "Domínios",
            dominio: "Domínio",
            estado: "Estado",
            gestaoDominio: "Gestão domínio",
            entidade: "Entidade",
            registar: "Registar",
            dataRegisto: "Data registo",
            validade: "Validade",
            entTitular: "Entidade Titular",
            entGestora: "Entidade Gestora",
            respTecnico: "Responsável Técnico",
        },
    // 'en':
    //     {
    //         add_new:            'Add new',
    //         birthday:         'Data de nascimento',
    //         cancel:             'Cancel', back: 'Voltar',
    //         close:              'Close',
    //         config:              'Clonfiguration',
    //         content:            'Content',
    //         content_edit:       'Edit content',
    //         content_new:        'New content',
    //         content_list:       'Content list',
    //         country:                'Country',
    //         country_placeholder:    'Insert country',
    //         city:                   'Cidade',
    //         city_placeholder:       'Introduza a cidade',
    //         district:               'Distrito',
    //         district_placeholder:   'Insert distrito',
    //         local:                  'Localidade',
    //         local_placeholder:      'Insert localidade',
    //         morada:                 'Address',
    //         morada_placeholder:     'Insert address',
    //         postal_code:                'Código-postal',
    //         postal_code_placeholder:    'Insert código-postal',
    //         village:                'Freguesia',
    //         village_placeholder:    'Insert freguesia',
    //         dates:              'Dates',
    //         date_creation:      'Creation',
    //         date_publication:   'Publication',
    //         date_last_update:   'Last update',
    //         delete:             'Delete',
    //         delete_title:       'Delete Regist',
    //         delete_text:        'Are you sure you want to continue?',
    //         delete_confirm:     'Yes',
    //         delete_cancel:      'No',
    //         delete_error:       'Problem deleting the element!',
    //         delete_success:     'Element deleted successfully!',
    //         description:        'Description',
    //         description_placeholder: 'Insert a description',
    //         edit:               'Edit',
    //         edit_title:         'Edit Regist',
    //         edit_text:          'Are you sure you want to continue?',
    //         edit_confirm:       'Yes',
    //         edit_cancel:        'No',
    //         edit_error:         'Problem updating element!',
    //         edit_success:       'Successful updated element!',
    //         email:              'E-mail ', 
    //         email_placeholder:  'Introduza o e-mail', 
    //         entity:             'Client', 
    //         entity_edit:        'Edit client', 
    //         entity_new:         'New client', 
    //         entity_list:        'Client List', 
    //         filter_placeholder: 'Search',
    //         id:                 'ID',
    //         language:           'Language',
    //         login_data:         'Login data',
    //         name:               'Name',
    //         name_placeholder:   'Insert the name',
    //         vat:                'NIF',
    //         vat_placeholder:    'Introduza o NIF',
    //         identification_number:              'Número de identificação',
    //         identification_number_placeholder:  'Introduza o número de identificação',
    //         identification_validation:          'Validade',
    //         image:              'Image',
    //         image_choose:       'Choose imagem',
    //         insert_title:       'New Regist',
    //         insert_text:        'Are you sure you want to continue?',
    //         insert_confirm:     'Yes',
    //         insert_cancel:      'No',
    //         insert_error:       'Problem updating element!',
    //         insert_success:     'Successful updated element!',
    //         password:           'Password',
    //         password_confirmation: 'Password confirmation',
    //         password_placeholder:   'Insert the password',
    //         password_text:      'The password do not match.',
    //         password_confirm:   'Continue',
    //         password_cancel:    'No',
    //         password_error:     'Problem inserting element!',
    //         password_success:   'Successful inserted element!', 
    //         personal_data:      'Personal data',
    //         principal:          'Principal',
    //         profile:            'Profile',
    //         remove:             'Remove',
    //         table_rows_per_page:'Regist by page:',
    //         table_separator:    'of',
    //         table_all:          'All',
    //         table_thumbnail:    'Thumbnail',
    //         table_title:        'Title',
    //         table_parent:       'Parent',
    //         table_date:         'Date',
    //         table_type:         'Type',
    //         table_count:        'Count',
    //         table_state:        'State',
    //         table_actions:      'Actions',
    //         table_empty:        'no results',
    //         text:               'Text',
    //         title:              'Title',
    //         title_placeholder:  'Insert title',
    //         tlf:                'Telefone', 
    //         tlf_placeholder:    'Introduza o número de telefone', 
    //         tlm:                'Telemóvel', 
    //         tlm_placeholder:    'Introduza o número de telemóvel', 
    //         type:               'Instuctor type',
    //         type_placeholder:   'Insert instructor type',
    //         type_identification:                'Tipo de identificação',
    //         type_identification_placeholder:    'Introduza o tipo de identificação',
    //         save:               'Save',
    //         username:           'Username',
    //         username_placeholder: 'Insert the username',
    //         warning_title:      'Warning!',
    //         warning_text:       'The username is already in the system.',
    //         warning_confirm:    'Continue',
    //         warning_cancel:     'No',
    //         warning_error:      'Problem inserting element!',
    //         warning_success:    'Successful inserted element!', 
    //     },
    // 'es': {

    //     }
}

module.exports = {
    language
};